import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { Time } from "@/helpers/time";
import ProxyActionRow from "./ProxyActionRow";
export default function ProxyActions(t0) {
  const $ = _c(8);
  const {
    profileProxy,
    profile,
    isSelf
  } = t0;
  let t1;
  let t2;
  if ($[0] !== isSelf || $[1] !== profile || $[2] !== profileProxy) {
    const actions = profileProxy.actions.toSorted(_temp);
    t1 = "tw-space-y-2.5 tw-mt-3";
    t2 = actions.map(action => <ProxyActionRow key={action.id} action={action} profileProxy={profileProxy} profile={profile} isSelf={isSelf} />);
    $[0] = isSelf;
    $[1] = profile;
    $[2] = profileProxy;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(a, d) {
  const aExpired = a.end_time && a.end_time < Time.currentMillis();
  const dExpired = d.end_time && d.end_time < Time.currentMillis();
  if (aExpired && !dExpired) {
    return 1;
  }
  if (!aExpired && dExpired) {
    return -1;
  }
  if (aExpired && dExpired) {
    return d.end_time - a.end_time;
  }
  return d.start_time - a.start_time;
}